// extracted by mini-css-extract-plugin
export var underlinedLink = "_of-0";